<template>
    <div class="app-container">
      <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :col-span="colSpan" :serial="true" @afterFetchOriginalData="afterFetchOriginalData" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.customer')" prop="customerList">
              <BjSelectLov v-model="queryParams.customerList" :option-list="customerListALL" multiple :placeholder="$t('customerNameText')" @change="handleQuery"/>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.type')" prop="typeList">
              <BjSelectLov v-model="queryParams.typeList" :option-list="typeAllList" multiple :placeholder="$t('screenWMS.type')" @change="handleQuery"/>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.Condition')" prop="conditionValue">
              <BjInput v-model="queryParams.conditionValue" :placeholder="$t('screenWMS.Condition')" @keyup.enter.native="handleQuery"/>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd()">{{ $t('addText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'customer'">{{ customerListALL.bjGet(scope.row.customer) }}</template>
                <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <template>
                  <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                  <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
                </template>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 新增编辑弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :model="form" label-position="top" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('screenWMS.customer')" prop="customer">
                <BjSelectLov v-model="form.customer" :option-list="customerListALL" @change="changeCustomer" :placeholder="$t('screenWMS.customer')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('screenWMS.type')" prop="type">
                <BjSelectLov v-model="form.type" :disabled="!form.customer" :option-list="typeDialogList" @change="clearConditionValue" :placeholder="$t('screenWMS.type')"/>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-if="form.type=='SKU' && isALL">
              <el-form-item label="SKU" prop="conditionValue">
                <el-select v-model="form.conditionValue" :remote-method="remoteMethod" :loading="loading" placeholder="SKU" filterable remote reserve-keyword style="width: 270px;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.type=='SKU' && !isALL">
              <el-form-item label="SKU" prop="conditionValue">
                <BjSelectLov v-model="form.conditionValue" :option-list="skuDialogList" placeholder="SKU"/>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.type=='Customer'">
              <el-form-item :label="$t('screenWMS.customer')" prop="conditionValue">
                <BjSelectLov v-model="form.conditionValue" :option-list="customerDialogList" :placeholder="$t('screenWMS.customer')"/>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="form.type=='Address'">
              <el-form-item :label="$t('screenWMS.Enter')" prop="conditionValue">
                <BjInput v-model="form.conditionValue" type="textarea" :rows="5" :maxlength="MAX_LENGTH.PRIORITY" show-word-limit autosize :placeholder="$t('screenWMS.Enter')" clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onSave()">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
  
    </div>
  </template>
  <script>
  import { waveApi,goodsApi } from '@/api';
  import pageMiXin from '@/utils/page-mixin.js';

  export default {
    name: 'WMSNSTD',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        selection: true,
        typeAllList:[{label:'SKU',value:'SKU'},{label:'Customer',value:'Customer'},{label:'Address',value:'Address'}],
        typeList:[{label:'SKU',value:'SKU'},{label:'Address',value:'Address'}],
        typeDialogList:[],
        queryApi: waveApi.getNSTDPage,
        queryParams: {
          customerList: [],
          typeList: [],
          conditionValue: null,
          tagTypeList: ['NSTD'],
        },
        labelList: [
          { label: this.$t('screenWMS.type'), prop: 'type', isCheck: true, disabled: false, },
          { label: this.$t('screenWMS.Condition'), prop: 'conditionValue', isCheck: true, disabled: false },
          { label: this.$t('screenWMS.Created'), prop: 'createdBy', isCheck: true, disabled: false },
          { label: this.$t('screenWMS.customer'), prop: 'customer', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width:120 },
        ],
  
        // 弹窗相关数据
        dialogTitle:null,
        dialogFormVisible: false,
        form: {
          id: null,
          customer: null,
          type: null,
          conditionValue: null,
          // 暂时写死 NSTD
          tagType: 'NSTD',
          // 创建人：当前登录人的 loginName
          createdBy: this.$store.getters.userInfo.loginName || null,
        },
        skuCodeList:[],
        rules: {
          customer: [{ required: true, message: this.$t('chooseText'), trigger: 'submit' }],
          type: [{ required: true, message: this.$t('chooseText'), trigger: 'submit' }],
        },
        skuDialogList:[],
        isALL:false,
        options: [],
        loading: false,
      };
    },
    computed:{
      customerListALL() {
        const data = this.$store.getters.customerList.map(item=>{
          return {label:item.label,value:item.clientCode,cusId:item.cusId}
        })
        data.unshift({ label: "ALL", value: "~" })
        return data
      },
      customerDialogList() {
        return this.$store.getters.customerList.map(item=>{
          return {label:item.label,value:item.label}
        })
      },
    },
    methods: {
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          goodsApi.getSku({skuCode:query,setFlag: 0, status: [3, 4, 5]}).then(res => {
            const resp = res.content.map(item => {
              return { label: item.skuCode, value: item.skuCode }
            });
            this.options = resp;
          });
          this.loading = false;
        } else {
          this.options = [];
        }
      },
      // 过滤页面数据
      afterFetchOriginalData(data) {
        data.content = data.records
        return data;
      },
      // 新增
      onAdd(){
        this.dialogTitle = this.$t('addText')
        this.options = []
        this.dialogFormVisible = true;
      },
      // 编辑
      onEdit(row){
        this.dialogTitle = this.$t('editText')
        const rowData = JSON.parse(JSON.stringify(row));

        if(rowData.customer == "~"){
          this.typeDialogList = this.typeAllList
          this.isALL = true
        }else{
          this.typeDialogList = this.typeList
          this.isALL = false
          const cusId = this.customerListALL.filter(item=> {return item.value == rowData.customer})[0].cusId
          this.getSkuList(cusId)
        }

        this.form = {
          ...rowData,
          // 暂时写死 NSTD
          tagType: 'NSTD',
          // 创建人：当前登录人的 loginName
          createdBy: this.$store.getters.userInfo.loginName || null,
        };
        this.dialogFormVisible = true;
      },
      // 选择客户后 赋值type下拉列表
      changeCustomer(n,m){
        this.form.type = null
        if(m.label == 'ALL'){
          this.isALL = true
          this.typeDialogList = this.typeAllList
          this.skuDialogList = []
        }else{
          this.options = []
          this.isALL = false
          this.typeDialogList = this.typeList
          this.getSkuList(m.cusId)
        }
        this.$refs.form.clearValidate();
      },
      // 切换type 清空 conditionValue
      clearConditionValue(){
        this.form.conditionValue = null
      },
      // 获取SKU下拉列表数据
      getSkuList(event){
        goodsApi.getSku({ cusId: event, setFlag: 0, status: [3, 4, 5] }).then(res=>{
          this.skuDialogList = res.content.map(item=>{
            return {label:item.skuCode,value:item.skuCode}
          })
        })
      },
      // 保存弹窗数据 并 关闭编辑弹窗
      onSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if(!this.form.conditionValue){
              if(this.form.type == "SKU" ) return this.$message.warning(this.$t('chooseText') + ' SKU')
              if(this.form.type == "Customer" ) return this.$message.warning(this.$t('chooseText') + this.$t('screenWMS.customer'))
              if(this.form.type == "Address" ) return this.$message.warning(this.$t('screenWMS.Enter'))
            }
            if(!this.form.id){
              waveApi.addNSTDList(this.form).then(res => {
                if(res.code == 200 || res.msg == "SUCCESS"){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.handleClose()
                  this.reFresh();
                }else{
                  this.$message.error(res.msg)
                }
              });
            }else{
              waveApi.editNSTDList(this.form).then(res => {
                if(res.code == 200 || res.msg == "SUCCESS"){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.handleClose()
                  this.reFresh();
                }else{
                  this.$message.error(res.msg)
                }
              });
            }
          }
        })
      },
      /** 关闭弹窗 清空数据 */
      handleClose() {
        this.form = {
          id: null,
          customer: null,
          type: null,
          conditionValue: null,
          // 暂时写死 NSTD
          tagType: 'NSTD',
          // 创建人：当前登录人的 loginName
          createdBy: this.$store.getters.userInfo.loginName || null,
        };
        this.$refs.form.resetFields();
        this.dialogFormVisible = false;
      },
      // 删除按钮
      onDel(row) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            waveApi.delNSTDList([row.id]).then(res => {
              if(res.code == 200 || res.msg == "SUCCESS"){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.reFresh();
              }else{
                this.$message.error(res.msg)
              }
            });
          })
          .catch(() => { });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  </style>
  